<template>
	<div
		v-if="runtimeConfig.public.ENABLE_COUPON_CODES"
		:class="{ 'mt-5': appliedCredits.length }">
		<div
			v-if="appliedCredits.length"
			class="mt-4 flex flex-col gap-2">
			<div
				v-for="credit in appliedCredits"
				:key="`${credit.code}-${credit.applied_amount}`"
				class="flex items-center justify-between rounded-md border-2 border-card-checkout-left-border bg-secondary/5 px-3 py-2 text-sm">
				<div>
					<p class="font-semibold text-primary">{{ credit.code }}</p>
					<p class="text-ternary">
						{{ $t("appliedCreditAmount") }}:
						{{ currency.symbol }}{{ numberHelper.formatPrice(Number(credit.applied_amount || 0)) }}
					</p>
				</div>

				<button
					type="button"
					class="flex h-8 w-8 items-center justify-center rounded-full text-card-checkout-left-border transition hover:bg-secondary/10 hover:text-card-checkout-left-border"
					:aria-label="$t('removeCredit', { code: credit.code })"
					@click="removeCreditCode(credit.code)">
					<IconsFontAwesome icon="fa-solid fa-trash" />
				</button>
			</div>
		</div>
	</div>
</template>

<script setup>
	import { useNuxtApp } from "#app"
	import numberHelper from "assets/helpers/numberHelper.js"
	import { useCartStore } from "~/stores/CartStore"
	import { useCurrencyStore } from "~/stores/CurrencyStore"
	import { storeToRefs } from "pinia"

	const runtimeConfig = useRuntimeConfig()
	const { $cartService } = useNuxtApp()

	const cartStore = useCartStore()
	const { cartId, appliedCredits, installments } = storeToRefs(cartStore)

	const currencyStore = useCurrencyStore()
	const { currency } = storeToRefs(currencyStore)

	const removeCreditCode = (code) => {
		$cartService.$removeCreditCode(code)
	}
</script>
